module.exports = __webpack_public_path__ + "static/media/Slide4.796d4106.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/fallbacks/home/Slide4.jpg
// module id = 581
// module chunks = 4